var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1281 14.3621C19.2361 14.3161 19.2901 14.2361 19.2901 14.1221H19.2921V8.89211C19.2921 8.78811 19.2381 8.71411 19.1301 8.66611C19.0201 8.61811 18.9221 8.63611 18.8341 8.72211L16.7241 10.7481V7.80011C16.7241 7.52611 16.6161 7.28611 16.4001 7.07811C16.1841 6.87011 15.9341 6.76611 15.6481 6.76611H7.57014C7.28614 6.76611 7.03414 6.87011 6.81814 7.07811C6.60214 7.28611 6.49414 7.52611 6.49414 7.80011V15.2281C6.49414 15.5021 6.60214 15.7421 6.81814 15.9501C7.03414 16.1581 7.28414 16.2621 7.57014 16.2621H15.6461C15.9321 16.2621 16.1821 16.1581 16.3981 15.9501C16.6141 15.7421 16.7221 15.5021 16.7221 15.2281V12.2801L18.8321 14.3061C18.9221 14.3901 19.0201 14.4101 19.1281 14.3621Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCamera);
export default __webpack_public_path__ + "static/media/markerCamera.88e711dbc6d574aa31cc85e89f7514ca.svg";
export { ForwardRef as ReactComponent };